import React, { Suspense, lazy } from "react";
import { aiAdsCluster, getRelatedMoneyPages, getRelatedIndustryPages, getRelatedInsightPages } from "@/data/contentClusters";

const MoneyPageTemplate = lazy(() => import("@/components/templates/MoneyPageTemplate").then((m) => ({ default: m.MoneyPageTemplate })));

const pageData = aiAdsCluster.moneyPages.find(p => p.slug === "google-ads-b2b")!;
const relatedMoney = getRelatedMoneyPages("ai-ads").filter(p => p.slug !== pageData.slug);
const relatedIndustry = getRelatedIndustryPages("ai-ads");
const relatedInsights = getRelatedInsightPages("ai-ads");

export default function GoogleAdsB2BPage() {
  return (
    <Suspense fallback={<div className="container-wide py-24">Loading…</div>}>
      <MoneyPageTemplate
        page={pageData}
        pillarTitle={aiAdsCluster.pillar.subtitle}
        relatedMoneyPages={relatedMoney.map(p => ({ title: p.title, slug: p.slug }))}
        relatedIndustryPages={relatedIndustry.map(p => ({ title: p.title, slug: p.slug }))}
        relatedInsightPages={relatedInsights.map(p => ({ title: p.title, slug: p.slug }))}
      />
    </Suspense>
  );
}
